
import { Question } from '../types';

export const partsOfSpeechQuestions: Question[] = [
  // Parts of Speech
  {
    id: 'q1',
    text: 'What is the correct definition of المبتدأ in Al-Ajrumiyyah?',
    type: 'single',
    options: [
      { id: 'a', text: 'The noun that comes at the beginning of a sentence', isCorrect: false },
      { id: 'b', text: 'The marfūʿ noun that is devoid of vocalized governors', isCorrect: true },
      { id: 'c', text: 'Any noun that is in the nominative case', isCorrect: false },
      { id: 'd', text: 'The subject of a verbal sentence', isCorrect: false }
    ],
    explanation: 'المبتدأ is defined in Al-Ajrumiyyah as "the marfūʿ noun that is devoid of vocalized governors" (الاسم المرفوع العاري عن العوامل اللفظية).',
    topic: 'parts-of-speech'
  },
  {
    id: 'q2',
    text: 'Which of the following is not one of the types of khabr (predicate) mentioned in Al-Ajrumiyyah?',
    type: 'single',
    options: [
      { id: 'a', text: 'الجار والمجرور (prepositional phrase)', isCorrect: false },
      { id: 'b', text: 'الفعل مع فاعله (verb with its subject)', isCorrect: false },
      { id: 'c', text: 'المبتدأ والخبر (subject and predicate)', isCorrect: false },
      { id: 'd', text: 'الظاهر (the apparent)', isCorrect: true },
      { id: 'e', text: 'الظرف (adverbial)', isCorrect: false },
      { id: 'f', text: 'اسم مفرد (single noun)', isCorrect: false }
    ],
    explanation: 'الظاهر (the apparent) is not one of the types of khabr mentioned in Al-Ajrumiyyah. The types mentioned are: single noun (مفرد), sentence consisting of subject and predicate (جملة من مبتدأ وخبر), sentence consisting of verb and subject (جملة من فعل وفاعل), prepositional phrase (جار ومجرور), and adverbial (ظرف).',
    topic: 'parts-of-speech'
  },
  {
    id: 'q3',
    text: 'According to Al-Ajrumiyyah, how is الكلام (speech) defined?',
    type: 'single',
    options: [
      { id: 'a', text: 'Any utterance in the Arabic language', isCorrect: false },
      { id: 'b', text: 'Words arranged in any order', isCorrect: false },
      { id: 'c', text: 'The composed, beneficial utterance by convention', isCorrect: true },
      { id: 'd', text: 'A collection of letters forming words', isCorrect: false }
    ],
    explanation: 'Al-Ajrumiyyah defines الكلام (speech) as "اللفظ المركّب المفيد بالوضع" which means "the composed, beneficial utterance by convention."',
    topic: 'parts-of-speech'
  },
  {
    id: 'q19',
    text: 'What are the three divisions of الكلمة (word) according to Al-Ajrumiyyah?',
    type: 'multiple',
    options: [
      { id: 'a', text: 'اسم (noun)', isCorrect: true },
      { id: 'b', text: 'فعل (verb)', isCorrect: true },
      { id: 'c', text: 'حرف (particle)', isCorrect: true },
      { id: 'd', text: 'صفة (adjective)', isCorrect: false },
      { id: 'e', text: 'ضمير (pronoun)', isCorrect: false },
      { id: 'f', text: 'ظرف (adverb)', isCorrect: false }
    ],
    explanation: 'According to Al-Ajrumiyyah, الكلمة (word) is divided into three types: اسم (noun), فعل (verb), and حرف (particle).',
    topic: 'parts-of-speech'
  },
  {
    id: 'q21',
    text: 'What is the sign of the noun (اسم) according to Al-Ajrumiyyah?',
    type: 'multiple',
    options: [
      { id: 'a', text: 'It accepts the definite article (ال)', isCorrect: true },
      { id: 'b', text: 'It accepts tanween', isCorrect: true },
      { id: 'c', text: 'It accepts prepositions', isCorrect: true },
      { id: 'd', text: 'It accepts the prefix (س)', isCorrect: false },
      { id: 'e', text: 'It accepts the jussive particles', isCorrect: false }
    ],
    explanation: 'According to Al-Ajrumiyyah, the signs of a noun include accepting the definite article (ال), tanween (التنوين), and prepositions (حروف الخفض).',
    topic: 'parts-of-speech'
  },
  {
    id: 'q22',
    text: 'What are the signs of the verb (فعل) according to Al-Ajrumiyyah?',
    type: 'multiple',
    options: [
      { id: 'a', text: 'It accepts قد', isCorrect: true },
      { id: 'b', text: 'It accepts س or سوف', isCorrect: true },
      { id: 'c', text: 'It accepts تاء الفاعل', isCorrect: true },
      { id: 'd', text: 'It accepts تاء التأنيث الساكنة', isCorrect: true },
      { id: 'e', text: 'It accepts the definite article (ال)', isCorrect: false },
      { id: 'f', text: 'It accepts tanween', isCorrect: false }
    ],
    explanation: 'According to Al-Ajrumiyyah, the signs of a verb include accepting قد, س or سوف, تاء الفاعل (subject pronoun تُ، تَ، تِ), and تاء التأنيث الساكنة (feminine marker تْ).',
    topic: 'parts-of-speech'
  },
  {
    id: 'q23',
    text: 'How does Al-Ajrumiyyah define the particle (حرف)?',
    type: 'single',
    options: [
      { id: 'a', text: 'A word that can be a subject or object', isCorrect: false },
      { id: 'b', text: 'A word that indicates an action', isCorrect: false },
      { id: 'c', text: 'A word that does not accept any signs of nouns or verbs', isCorrect: true },
      { id: 'd', text: 'A word that accepts prepositions', isCorrect: false }
    ],
    explanation: 'Al-Ajrumiyyah defines the particle (حرف) as "ما لا يصلح معه دليل الاسم ولا دليل الفعل" - that which does not accept any signs of nouns or verbs.',
    topic: 'parts-of-speech'
  },
  {
    id: 'ps1',
    text: 'In the sentence زيدٌ قائمٌ (Zayd is standing), identify the المبتدأ (subject):',
    type: 'single',
    options: [
      { id: 'a', text: 'زيدٌ', isCorrect: true },
      { id: 'b', text: 'قائمٌ', isCorrect: false }
    ],
    explanation: 'In this nominal sentence, زيدٌ is the المبتدأ (subject) because it is the marfūʿ noun at the beginning of the sentence that is devoid of vocalized governors.',
    topic: 'parts-of-speech'
  },
  {
    id: 'ps2',
    text: 'What is the English translation of المفعول به in Al-Ajrumiyyah terminology?',
    type: 'single',
    options: [
      { id: 'a', text: 'Subject', isCorrect: false },
      { id: 'b', text: 'Direct object', isCorrect: true },
      { id: 'c', text: 'Indirect object', isCorrect: false },
      { id: 'd', text: 'Adverb', isCorrect: false }
    ],
    explanation: 'المفعول به means "the direct object" in English. It refers to the noun that receives the action of the verb.',
    topic: 'parts-of-speech'
  },
  {
    id: 'ps3',
    text: 'In the sentence قرأَ محمدٌ الكتابَ (Muhammad read the book), identify the فعل (verb):',
    type: 'single',
    options: [
      { id: 'a', text: 'قرأَ', isCorrect: true },
      { id: 'b', text: 'محمدٌ', isCorrect: false },
      { id: 'c', text: 'الكتابَ', isCorrect: false }
    ],
    explanation: 'In this sentence, قرأَ (read) is the فعل (verb) as it indicates an action and shows the signs of a verb.',
    topic: 'parts-of-speech'
  },
  {
    id: 'ps4',
    text: 'What is the English translation of الحال in Al-Ajrumiyyah terminology?',
    type: 'single',
    options: [
      { id: 'a', text: 'Adverb', isCorrect: false },
      { id: 'b', text: 'Circumstantial accusative', isCorrect: true },
      { id: 'c', text: 'Direct object', isCorrect: false },
      { id: 'd', text: 'State or condition', isCorrect: false }
    ],
    explanation: 'الحال translates to "circumstantial accusative" in English grammatical terms. It describes the state or condition of the subject or object at the time of an action.',
    topic: 'parts-of-speech'
  },
  {
    id: 'ps5',
    text: 'In the sentence ذهبَ الطالبُ إلى المدرسةِ (The student went to school), identify the حرف الجر (preposition):',
    type: 'single',
    options: [
      { id: 'a', text: 'ذهبَ', isCorrect: false },
      { id: 'b', text: 'الطالبُ', isCorrect: false },
      { id: 'c', text: 'إلى', isCorrect: true },
      { id: 'd', text: 'المدرسةِ', isCorrect: false }
    ],
    explanation: 'إلى (to) is the حرف الجر (preposition) in this sentence. It belongs to the category of حرف (particle) and puts the noun after it in the genitive case.',
    topic: 'parts-of-speech'
  },
  // Adding more questions about parts of speech
  {
    id: 'ps6',
    text: 'In the sentence جاءَ الرجلُ سريعاً (The man came quickly), identify the المفعول المطلق:',
    type: 'single',
    options: [
      { id: 'a', text: 'جاءَ', isCorrect: false },
      { id: 'b', text: 'الرجلُ', isCorrect: false },
      { id: 'c', text: 'سريعاً', isCorrect: true }
    ],
    explanation: 'سريعاً (quickly) is the الحال (circumstantial accusative) in this sentence. It describes the state of the subject (الرجل) at the time of the action.',
    topic: 'parts-of-speech'
  },
  {
    id: 'ps7',
    text: 'What is the English translation of التمييز in Al-Ajrumiyyah terminology?',
    type: 'single',
    options: [
      { id: 'a', text: 'Adverb', isCorrect: false },
      { id: 'b', text: 'Specification', isCorrect: true },
      { id: 'c', text: 'Direct object', isCorrect: false },
      { id: 'd', text: 'Circumstance', isCorrect: false }
    ],
    explanation: 'التمييز translates to "specification" in English grammatical terms. It is a noun in the accusative case that removes ambiguity from the sentence.',
    topic: 'parts-of-speech'
  },
  {
    id: 'ps8',
    text: 'In the sentence اشتريتُ عشرين كتاباً (I bought twenty books), identify the تمييز (specification):',
    type: 'single',
    options: [
      { id: 'a', text: 'اشتريتُ', isCorrect: false },
      { id: 'b', text: 'عشرين', isCorrect: false },
      { id: 'c', text: 'كتاباً', isCorrect: true }
    ],
    explanation: 'كتاباً (books) is the تمييز (specification) in this sentence. It specifies what was counted by the number (عشرين).',
    topic: 'parts-of-speech'
  },
  {
    id: 'ps9',
    text: 'What is the English translation of المنادى in Al-Ajrumiyyah terminology?',
    type: 'single',
    options: [
      { id: 'a', text: 'The vocative', isCorrect: true },
      { id: 'b', text: 'The predicate', isCorrect: false },
      { id: 'c', text: 'The subject', isCorrect: false },
      { id: 'd', text: 'The object', isCorrect: false }
    ],
    explanation: 'المنادى translates to "the vocative" in English grammatical terms. It refers to the person or thing being called or addressed.',
    topic: 'parts-of-speech'
  },
  {
    id: 'ps10',
    text: 'In the sentence يا طالباً، اجتهد في دراستك (O student, work hard in your studies), identify the منادى (vocative):',
    type: 'single',
    options: [
      { id: 'a', text: 'يا', isCorrect: false },
      { id: 'b', text: 'طالباً', isCorrect: true },
      { id: 'c', text: 'اجتهد', isCorrect: false },
      { id: 'd', text: 'دراستك', isCorrect: false }
    ],
    explanation: 'طالباً (student) is the منادى (vocative) in this sentence. It is the person being addressed, and it comes after the vocative particle يا.',
    topic: 'parts-of-speech'
  },
  {
    id: 'ps11',
    text: 'What is the English translation of البدل in Al-Ajrumiyyah terminology?',
    type: 'single',
    options: [
      { id: 'a', text: 'The apposition', isCorrect: false },
      { id: 'b', text: 'The substitute', isCorrect: true },
      { id: 'c', text: 'The adjective', isCorrect: false },
      { id: 'd', text: 'The adverb', isCorrect: false }
    ],
    explanation: 'البدل translates to "the substitute" in English grammatical terms. It is a form of apposition where one noun substitutes for another.',
    topic: 'parts-of-speech'
  },
  {
    id: 'ps12',
    text: 'In the sentence جاء أخوك محمدٌ (Your brother Muhammad came), identify the بدل (substitute):',
    type: 'single',
    options: [
      { id: 'a', text: 'جاء', isCorrect: false },
      { id: 'b', text: 'أخوك', isCorrect: false },
      { id: 'c', text: 'محمدٌ', isCorrect: true }
    ],
    explanation: 'محمدٌ (Muhammad) is the بدل (substitute) in this sentence. It substitutes for أخوك (your brother) by providing more specific information.',
    topic: 'parts-of-speech'
  },
  {
    id: 'ps13',
    text: 'What is the English translation of النعت in Al-Ajrumiyyah terminology?',
    type: 'single',
    options: [
      { id: 'a', text: 'The adjective', isCorrect: true },
      { id: 'b', text: 'The adverb', isCorrect: false },
      { id: 'c', text: 'The preposition', isCorrect: false },
      { id: 'd', text: 'The conjunction', isCorrect: false }
    ],
    explanation: 'النعت translates to "the adjective" in English grammatical terms. It describes a quality of the noun it modifies.',
    topic: 'parts-of-speech'
  },
  {
    id: 'ps14',
    text: 'In the sentence رأيتُ الرجلَ الكريمَ (I saw the generous man), identify the نعت (adjective):',
    type: 'single',
    options: [
      { id: 'a', text: 'رأيتُ', isCorrect: false },
      { id: 'b', text: 'الرجلَ', isCorrect: false },
      { id: 'c', text: 'الكريمَ', isCorrect: true }
    ],
    explanation: 'الكريمَ (generous) is the نعت (adjective) in this sentence. It describes a quality of الرجل (the man).',
    topic: 'parts-of-speech'
  },
  {
    id: 'ps15',
    text: 'What is the English translation of المضاف إليه in Al-Ajrumiyyah terminology?',
    type: 'single',
    options: [
      { id: 'a', text: 'The possessed', isCorrect: true },
      { id: 'b', text: 'The possessor', isCorrect: false },
      { id: 'c', text: 'The direct object', isCorrect: false },
      { id: 'd', text: 'The indirect object', isCorrect: false }
    ],
    explanation: 'المضاف إليه translates to "the possessed" in English grammatical terms. In a genitive construction (إضافة), it is the second term that possesses the first term.',
    topic: 'parts-of-speech'
  },
  {
    id: 'ps16',
    text: 'In the sentence هذا كتابُ الطالبِ (This is the student\'s book), identify the مضاف إليه (possessed):',
    type: 'single',
    options: [
      { id: 'a', text: 'هذا', isCorrect: false },
      { id: 'b', text: 'كتابُ', isCorrect: false },
      { id: 'c', text: 'الطالبِ', isCorrect: true }
    ],
    explanation: 'الطالبِ (the student) is the مضاف إليه (possessed) in this sentence. It is in the genitive case because it is the second term in the genitive construction (إضافة).',
    topic: 'parts-of-speech'
  },
  {
    id: 'ps17',
    text: 'What is the English translation of المفعول المطلق in Al-Ajrumiyyah terminology?',
    type: 'single',
    options: [
      { id: 'a', text: 'The absolute object', isCorrect: true },
      { id: 'b', text: 'The direct object', isCorrect: false },
      { id: 'c', text: 'The accusative of specification', isCorrect: false },
      { id: 'd', text: 'The circumstantial accusative', isCorrect: false }
    ],
    explanation: 'المفعول المطلق translates to "the absolute object" in English grammatical terms. It is a verbal noun (مصدر) derived from the same root as the verb of the sentence.',
    topic: 'parts-of-speech'
  },
  {
    id: 'ps18',
    text: 'In the sentence ضربتُ ضرباً (I really hit), identify the مفعول مطلق (absolute object):',
    type: 'single',
    options: [
      { id: 'a', text: 'ضربتُ', isCorrect: false },
      { id: 'b', text: 'ضرباً', isCorrect: true }
    ],
    explanation: 'ضرباً (really) is the مفعول مطلق (absolute object) in this sentence. It is a verbal noun (مصدر) derived from the same root as the verb ضربتُ.',
    topic: 'parts-of-speech'
  },
  {
    id: 'ps19',
    text: 'What is the English translation of المفعول لأجله in Al-Ajrumiyyah terminology?',
    type: 'single',
    options: [
      { id: 'a', text: 'The accusative of reason or purpose', isCorrect: true },
      { id: 'b', text: 'The direct object', isCorrect: false },
      { id: 'c', text: 'The circumstantial accusative', isCorrect: false },
      { id: 'd', text: 'The absolute object', isCorrect: false }
    ],
    explanation: 'المفعول لأجله translates to "the accusative of reason or purpose" in English grammatical terms. It explains why an action was done.',
    topic: 'parts-of-speech'
  },
  {
    id: 'ps20',
    text: 'In the sentence قمتُ احتراماً للأستاذ (I stood up out of respect for the professor), identify the مفعول لأجله (accusative of reason):',
    type: 'single',
    options: [
      { id: 'a', text: 'قمتُ', isCorrect: false },
      { id: 'b', text: 'احتراماً', isCorrect: true },
      { id: 'c', text: 'للأستاذ', isCorrect: false }
    ],
    explanation: 'احتراماً (out of respect) is the مفعول لأجله (accusative of reason) in this sentence. It explains why the action (standing up) was performed.',
    topic: 'parts-of-speech'
  },
  {
    id: 'ps21',
    text: 'What is the English translation of المفعول فيه in Al-Ajrumiyyah terminology?',
    type: 'single',
    options: [
      { id: 'a', text: 'The direct object', isCorrect: false },
      { id: 'b', text: 'The object of place or time (adverbial accusative)', isCorrect: true },
      { id: 'c', text: 'The circumstantial accusative', isCorrect: false },
      { id: 'd', text: 'The absolute object', isCorrect: false }
    ],
    explanation: 'المفعول فيه translates to "the object of place or time" or "adverbial accusative" in English grammatical terms. It indicates when or where an action takes place.',
    topic: 'parts-of-speech'
  },
  {
    id: 'ps22',
    text: 'In the sentence صمتُ يوماً (I fasted for a day), identify the مفعول فيه (adverbial accusative):',
    type: 'single',
    options: [
      { id: 'a', text: 'صمتُ', isCorrect: false },
      { id: 'b', text: 'يوماً', isCorrect: true }
    ],
    explanation: 'يوماً (a day) is the مفعول فيه (adverbial accusative) in this sentence. It indicates when the action (fasting) took place.',
    topic: 'parts-of-speech'
  },
  {
    id: 'ps23',
    text: 'What is the English translation of المفعول معه in Al-Ajrumiyyah terminology?',
    type: 'single',
    options: [
      { id: 'a', text: 'The direct object', isCorrect: false },
      { id: 'b', text: 'The object of accompaniment', isCorrect: true },
      { id: 'c', text: 'The circumstantial accusative', isCorrect: false },
      { id: 'd', text: 'The absolute object', isCorrect: false }
    ],
    explanation: 'المفعول معه translates to "the object of accompaniment" in English grammatical terms. It is a noun in the accusative case preceded by واو المعية (the waw of accompaniment).',
    topic: 'parts-of-speech'
  },
  {
    id: 'ps24',
    text: 'In the sentence سرتُ والنهرَ (I walked alongside the river), identify the مفعول معه (object of accompaniment):',
    type: 'single',
    options: [
      { id: 'a', text: 'سرتُ', isCorrect: false },
      { id: 'b', text: 'و', isCorrect: false },
      { id: 'c', text: 'النهرَ', isCorrect: true }
    ],
    explanation: 'النهرَ (the river) is the مفعول معه (object of accompaniment) in this sentence. It is in the accusative case and is preceded by واو المعية (the waw of accompaniment).',
    topic: 'parts-of-speech'
  },
  {
    id: 'ps25',
    text: 'What is the difference between الفاعل and نائب الفاعل in Al-Ajrumiyyah?',
    type: 'single',
    options: [
      { id: 'a', text: 'الفاعل is the subject of an active verb, while نائب الفاعل is the subject of a passive verb', isCorrect: true },
      { id: 'b', text: 'الفاعل is the direct object, while نائب الفاعل is the indirect object', isCorrect: false },
      { id: 'c', text: 'الفاعل is only used with past tense verbs, while نائب الفاعل is used with present tense verbs', isCorrect: false },
      { id: 'd', text: 'There is no difference; they are synonyms', isCorrect: false }
    ],
    explanation: 'الفاعل (the doer) is the subject of an active verb, while نائب الفاعل (the deputy of the doer) is the subject of a passive verb. In a passive construction, the direct object of the active sentence becomes the نائب الفاعل.',
    topic: 'parts-of-speech'
  },
  {
    id: 'ps26',
    text: 'In the sentence فُتِحَ البابُ (The door was opened), identify the نائب الفاعل (deputy of the doer):',
    type: 'single',
    options: [
      { id: 'a', text: 'فُتِحَ', isCorrect: false },
      { id: 'b', text: 'البابُ', isCorrect: true }
    ],
    explanation: 'البابُ (the door) is the نائب الفاعل (deputy of the doer) in this passive sentence. It is the subject of the passive verb فُتِحَ (was opened).',
    topic: 'parts-of-speech'
  },
  {
    id: 'ps27',
    text: 'What is the English translation of اسم الفاعل in Al-Ajrumiyyah terminology?',
    type: 'single',
    options: [
      { id: 'a', text: 'The active participle', isCorrect: true },
      { id: 'b', text: 'The passive participle', isCorrect: false },
      { id: 'c', text: 'The verbal noun', isCorrect: false },
      { id: 'd', text: 'The gerund', isCorrect: false }
    ],
    explanation: 'اسم الفاعل translates to "the active participle" in English grammatical terms. It is a derived nominal form that indicates the doer of an action.',
    topic: 'parts-of-speech'
  },
  {
    id: 'ps28',
    text: 'In the sentence هذا كاتبٌ ماهرٌ (This is a skilled writer), identify the اسم الفاعل (active participle):',
    type: 'single',
    options: [
      { id: 'a', text: 'هذا', isCorrect: false },
      { id: 'b', text: 'كاتبٌ', isCorrect: true },
      { id: 'c', text: 'ماهرٌ', isCorrect: true }
    ],
    explanation: 'كاتبٌ (writer) is the اسم الفاعل (active participle) in this sentence. It is derived from the verb كتب (to write) and indicates the doer of the action.',
    topic: 'parts-of-speech'
  },
  {
    id: 'ps29',
    text: 'What is the English translation of اسم المفعول in Al-Ajrumiyyah terminology?',
    type: 'single',
    options: [
      { id: 'a', text: 'The active participle', isCorrect: false },
      { id: 'b', text: 'The passive participle', isCorrect: true },
      { id: 'c', text: 'The verbal noun', isCorrect: false },
      { id: 'd', text: 'The gerund', isCorrect: false }
    ],
    explanation: 'اسم المفعول translates to "the passive participle" in English grammatical terms. It is a derived nominal form that indicates the object of an action.',
    topic: 'parts-of-speech'
  },
  {
    id: 'ps30',
    text: 'In the sentence الكتابُ مقروءٌ (The book is read), identify the اسم المفعول (passive participle):',
    type: 'single',
    options: [
      { id: 'a', text: 'الكتابُ', isCorrect: false },
      { id: 'b', text: 'مقروءٌ', isCorrect: true }
    ],
    explanation: 'مقروءٌ (read) is the اسم المفعول (passive participle) in this sentence. It is derived from the verb قرأ (to read) and indicates the object of the action.',
    topic: 'parts-of-speech'
  },
  {
    id: 'ps31',
    text: 'What is the English translation of المعرب in Al-Ajrumiyyah terminology?',
    type: 'single',
    options: [
      { id: 'a', text: 'The declension', isCorrect: false },
      { id: 'b', text: 'The inflected word', isCorrect: true },
      { id: 'c', text: 'The indeclinable word', isCorrect: false },
      { id: 'd', text: 'The parser', isCorrect: false }
    ],
    explanation: 'المعرب translates to "the inflected word" in English grammatical terms. It refers to words whose endings change according to their grammatical function in the sentence.',
    topic: 'parts-of-speech'
  },
  {
    id: 'ps32',
    text: 'What is the English translation of المبني in Al-Ajrumiyyah terminology?',
    type: 'single',
    options: [
      { id: 'a', text: 'The declension', isCorrect: false },
      { id: 'b', text: 'The inflected word', isCorrect: false },
      { id: 'c', text: 'The uninflected word', isCorrect: true },
      { id: 'd', text: 'The builder', isCorrect: false }
    ],
    explanation: 'المبني translates to "the uninflected word" in English grammatical terms. It refers to words whose endings do not change regardless of their grammatical function in the sentence.',
    topic: 'parts-of-speech'
  },
  {
    id: 'ps33',
    text: 'What is the English translation of المصدر in Al-Ajrumiyyah terminology?',
    type: 'single',
    options: [
      { id: 'a', text: 'The source', isCorrect: false },
      { id: 'b', text: 'The verbal noun', isCorrect: true },
      { id: 'c', text: 'The infinitive', isCorrect: false },
      { id: 'd', text: 'The gerund', isCorrect: false }
    ],
    explanation: 'المصدر translates to "the verbal noun" in English grammatical terms. It is a noun that denotes the action of the verb without any indication of time.',
    topic: 'parts-of-speech'
  },
  {
    id: 'ps34',
    text: 'In the sentence أُحِبُّ القراءةَ (I love reading), identify the مصدر (verbal noun):',
    type: 'single',
    options: [
      { id: 'a', text: 'أُحِبُّ', isCorrect: false },
      { id: 'b', text: 'القراءةَ', isCorrect: true }
    ],
    explanation: 'القراءةَ (reading) is the مصدر (verbal noun) in this sentence. It is derived from the verb قرأ (to read) and denotes the action without any indication of time.',
    topic: 'parts-of-speech'
  },
  {
    id: 'ps35',
    text: 'What is the English translation of الضمير in Al-Ajrumiyyah terminology?',
    type: 'single',
    options: [
      { id: 'a', text: 'The pronoun', isCorrect: true },
      { id: 'b', text: 'The conscience', isCorrect: false },
      { id: 'c', text: 'The hidden', isCorrect: false },
      { id: 'd', text: 'The secret', isCorrect: false }
    ],
    explanation: 'الضمير translates to "the pronoun" in English grammatical terms. It is a word that stands for a noun.',
    topic: 'parts-of-speech'
  },
  {
    id: 'ps36',
    text: 'In the sentence قرأتُ الكتابَ (I read the book), identify the ضمير (pronoun):',
    type: 'single',
    options: [
      { id: 'a', text: 'تُ in قرأتُ', isCorrect: true },
      { id: 'b', text: 'قرأ', isCorrect: false },
      { id: 'c', text: 'الكتابَ', isCorrect: false }
    ],
    explanation: 'تُ in قرأتُ is the ضمير (pronoun) in this sentence. It is an attached pronoun that serves as the subject (فاعل) of the verb.',
    topic: 'parts-of-speech'
  },
  {
    id: 'ps37',
    text: 'What is the English translation of اسم الإشارة in Al-Ajrumiyyah terminology?',
    type: 'single',
    options: [
      { id: 'a', text: 'The demonstrative pronoun', isCorrect: true },
      { id: 'b', text: 'The relative pronoun', isCorrect: false },
      { id: 'c', text: 'The interrogative pronoun', isCorrect: false },
      { id: 'd', text: 'The personal pronoun', isCorrect: false }
    ],
    explanation: 'اسم الإشارة translates to "the demonstrative pronoun" in English grammatical terms. It is a word used to point to something specific.',
    topic: 'parts-of-speech'
  },
  {
    id: 'ps38',
    text: 'In the sentence هذا بيت (This is a house), identify the اسم إشارة (demonstrative pronoun):',
    type: 'single',
    options: [
      { id: 'a', text: 'هذا', isCorrect: true },
      { id: 'b', text: 'بيت', isCorrect: false }
    ],
    explanation: 'هذا (this) is the اسم إشارة (demonstrative pronoun) in this sentence. It points to a specific thing that is near to the speaker.',
    topic: 'parts-of-speech'
  },
  {
    id: 'ps39',
    text: 'What is the English translation of الاسم الموصول in Al-Ajrumiyyah terminology?',
    type: 'single',
    options: [
      { id: 'a', text: 'The demonstrative pronoun', isCorrect: false },
      { id: 'b', text: 'The relative pronoun', isCorrect: true },
      { id: 'c', text: 'The interrogative pronoun', isCorrect: false },
      { id: 'd', text: 'The personal pronoun', isCorrect: false }
    ],
    explanation: 'الاسم الموصول translates to "the relative pronoun" in English grammatical terms. It is a word that introduces a relative clause.',
    topic: 'parts-of-speech'
  },
  {
    id: 'ps40',
    text: 'In the sentence جاء الذي نجح (The one who succeeded came), identify the اسم موصول (relative pronoun):',
    type: 'single',
    options: [
      { id: 'a', text: 'جاء', isCorrect: false },
      { id: 'b', text: 'الذي', isCorrect: true },
      { id: 'c', text: 'نجح', isCorrect: false }
    ],
    explanation: 'الذي (who) is the اسم موصول (relative pronoun) in this sentence. It introduces the relative clause نجح (succeeded).',
    topic: 'parts-of-speech'
  },
  {
    id: 'ps41',
    text: 'What is the English translation of اسم الاستفهام in Al-Ajrumiyyah terminology?',
    type: 'single',
    options: [
      { id: 'a', text: 'The demonstrative pronoun', isCorrect: false },
      { id: 'b', text: 'The relative pronoun', isCorrect: false },
      { id: 'c', text: 'The interrogative pronoun', isCorrect: true },
      { id: 'd', text: 'The personal pronoun', isCorrect: false }
    ],
    explanation: 'اسم الاستفهام translates to "the interrogative pronoun" in English grammatical terms. It is a word used to ask questions.',
    topic: 'parts-of-speech'
  },
  {
    id: 'ps42',
    text: 'In the sentence من جاء؟ (Who came?), identify the اسم استفهام (interrogative pronoun):',
    type: 'single',
    options: [
      { id: 'a', text: 'من', isCorrect: true },
      { id: 'b', text: 'جاء', isCorrect: false }
    ],
    explanation: 'من (who) is the اسم استفهام (interrogative pronoun) in this sentence. It is used to ask about people.',
    topic: 'parts-of-speech'
  },
  {
    id: 'ps43',
    text: 'What is the English translation of اسم الشرط in Al-Ajrumiyyah terminology?',
    type: 'single',
    options: [
      { id: 'a', text: 'The conditional noun', isCorrect: true },
      { id: 'b', text: 'The conjunctive noun', isCorrect: false },
      { id: 'c', text: 'The interrogative noun', isCorrect: false },
      { id: 'd', text: 'The relative noun', isCorrect: false }
    ],
    explanation: 'اسم الشرط translates to "the conditional noun" in English grammatical terms. It is a noun used to introduce a conditional sentence.',
    topic: 'parts-of-speech'
  },
  {
    id: 'ps44',
    text: 'In the sentence من يدرسْ ينجحْ (Whoever studies succeeds), identify the اسم شرط (conditional noun):',
    type: 'single',
    options: [
      { id: 'a', text: 'من', isCorrect: true },
      { id: 'b', text: 'يدرسْ', isCorrect: false },
      { id: 'c', text: 'ينجحْ', isCorrect: false }
    ],
    explanation: 'من (whoever) is the اسم شرط (conditional noun) in this sentence. It introduces a conditional sentence where the action in the second clause (ينجحْ) depends on the action in the first clause (يدرسْ).',
    topic: 'parts-of-speech'
  },
  {
    id: 'ps45',
    text: 'What is the English translation of حروف العطف in Al-Ajrumiyyah terminology?',
    type: 'single',
    options: [
      { id: 'a', text: 'The particles of exception', isCorrect: false },
      { id: 'b', text: 'The particles of conjunction', isCorrect: true },
      { id: 'c', text: 'The particles of condition', isCorrect: false },
      { id: 'd', text: 'The particles of negation', isCorrect: false }
    ],
    explanation: 'حروف العطف translates to "the particles of conjunction" in English grammatical terms. They are particles used to join words, phrases, or clauses.',
    topic: 'parts-of-speech'
  },
  {
    id: 'ps46',
    text: 'In the sentence جاء زيدٌ وعمروٌ (Zayd and Amr came), identify the حرف عطف (conjunction):',
    type: 'single',
    options: [
      { id: 'a', text: 'جاء', isCorrect: false },
      { id: 'b', text: 'زيدٌ', isCorrect: false },
      { id: 'c', text: 'و', isCorrect: true },
      { id: 'd', text: 'عمروٌ', isCorrect: false }
    ],
    explanation: 'و (and) is the حرف عطف (conjunction) in this sentence. It joins the two nouns زيدٌ and عمروٌ.',
    topic: 'parts-of-speech'
  },
  {
    id: 'ps47',
    text: 'What is the English translation of حروف النفي in Al-Ajrumiyyah terminology?',
    type: 'single',
    options: [
      { id: 'a', text: 'The particles of exception', isCorrect: false },
      { id: 'b', text: 'The particles of conjunction', isCorrect: false },
      { id: 'c', text: 'The particles of condition', isCorrect: false },
      { id: 'd', text: 'The particles of negation', isCorrect: true }
    ],
    explanation: 'حروف النفي translates to "the particles of negation" in English grammatical terms. They are particles used to negate a statement.',
    topic: 'parts-of-speech'
  },
  {
    id: 'ps48',
    text: 'In the sentence ما جاء زيدٌ (Zayd did not come), identify the حرف نفي (negation particle):',
    type: 'single',
    options: [
      { id: 'a', text: 'ما', isCorrect: true },
      { id: 'b', text: 'جاء', isCorrect: false },
      { id: 'c', text: 'زيدٌ', isCorrect: false }
    ],
    explanation: 'ما (not) is the حرف نفي (negation particle) in this sentence. It negates the verb جاء (came).',
    topic: 'parts-of-speech'
  }
];
